import { useNavigate } from 'react-router-dom';
import PublicLegalPage from '@/components/PublicLegalPage';
import { GDPR_PAGE_CONTENT, PUBLIC_CORE_LINK_LABELS } from '../../ui-foundation';

export default function GdprPage() {
  const navigate = useNavigate();

  return (
    <PublicLegalPage
      title={GDPR_PAGE_CONTENT.title}
      subtitle={GDPR_PAGE_CONTENT.subtitle}
      introBody={GDPR_PAGE_CONTENT.introBody}
      sections={GDPR_PAGE_CONTENT.sections}
      actions={[
        { label: PUBLIC_CORE_LINK_LABELS.privacy, onPress: () => navigate('/privacy'), tone: 'outline' },
        { label: PUBLIC_CORE_LINK_LABELS.terms, onPress: () => navigate('/terms'), tone: 'outline' },
        { label: PUBLIC_CORE_LINK_LABELS.contactSupport, onPress: () => navigate('/contact-complaints'), tone: 'outline' },
      ]}
    />
  );
}
